import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as r } from "../chunks/tslib.es6.js";
import { clone as t } from "../core/lang.js";
import { toPt as e } from "../core/screenUtils.js";
import { property as o } from "../core/accessorSupport/decorators/property.js";
import "../core/accessorSupport/ensureType.js";
import { enumeration as s } from "../core/accessorSupport/decorators/enumeration.js";
import { reader as i } from "../core/accessorSupport/decorators/reader.js";
import { subclass as p } from "../core/accessorSupport/decorators/subclass.js";
import h from "./MarkerSymbol.js";
import { urlPropertyDefinition as u, sourcePropertyDefinition as c } from "./support/urlUtils.js";

var _l;

var a = _l = /*#__PURE__*/function (_h) {
  _inherits(l, _h);

  var _super = _createSuper(l);

  function l() {
    var _this;

    _classCallCheck(this, l);

    for (var _len = arguments.length, r = new Array(_len), _key = 0; _key < _len; _key++) {
      r[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(r)), _this.color = null, _this.type = "picture-marker", _this.url = null, _this.source = null, _this.height = 12, _this.width = 12, _this.size = null;
    return _this;
  }

  _createClass(l, [{
    key: "normalizeCtorArgs",
    value: function normalizeCtorArgs(r, t, o) {
      if (r && "string" != typeof r && null == r.imageData) return r;
      var s = {};
      return r && (s.url = r), null != t && (s.width = e(t)), null != o && (s.height = e(o)), s;
    }
  }, {
    key: "readHeight",
    value: function readHeight(r, t) {
      return t.size || r;
    }
  }, {
    key: "readWidth",
    value: function readWidth(r, t) {
      return t.size || r;
    }
  }, {
    key: "clone",
    value: function clone() {
      var r = new _l({
        angle: this.angle,
        height: this.height,
        url: this.url,
        width: this.width,
        xoffset: this.xoffset,
        yoffset: this.yoffset
      });
      return r._set("source", t(this.source)), r;
    }
  }, {
    key: "hash",
    value: function hash() {
      return "".concat(_get(_getPrototypeOf(l.prototype), "hash", this).call(this), ".").concat(this.height, ".").concat(this.url, ".").concat(this.width);
    }
  }]);

  return l;
}(h);

r([o({
  json: {
    write: !1
  }
})], a.prototype, "color", void 0), r([s({
  esriPMS: "picture-marker"
}, {
  readOnly: !0
})], a.prototype, "type", void 0), r([o(u)], a.prototype, "url", void 0), r([o(c)], a.prototype, "source", void 0), r([o({
  type: Number,
  cast: e,
  json: {
    write: !0
  }
})], a.prototype, "height", void 0), r([i("height", ["height", "size"])], a.prototype, "readHeight", null), r([o({
  type: Number,
  cast: e,
  json: {
    write: !0
  }
})], a.prototype, "width", void 0), r([o({
  json: {
    write: !1
  }
})], a.prototype, "size", void 0), a = _l = r([p("esri.symbols.PictureMarkerSymbol")], a);
var n = a;
export { n as default };